import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createOrUpdateMaterialBOMApi,
  createOrUpdateProductBOMApi,
  getMaterialBOMByIdApi,
  getProductBOMByIdApi,
} from "../../api/product.api";
import ResponseModel from "../../models/response.model";
interface IProductBOM {
  _id?: string;
  productId?: string;
  materialId?: string;
  components: Array<{
    componentType: "material" | "product";
    componentId: string;
    quantity: number;
    unit?: string;
  }>;
}
interface ProductBOMState {
  loading: boolean;
  selectedBom: IProductBOM | null;
}

const initialState: ProductBOMState = {
  loading: false,
  selectedBom: null,
};

export const getProductBOMById = createAsyncThunk(
  "products/getProductByBOMId",
  async (bomId: string, { rejectWithValue }) => {
    try {
      const bom = await getProductBOMByIdApi(bomId);
      return bom;
    } catch (error: any) {
      return rejectWithValue(error?.message || "Failed to get Product BOM");
    }
  },
);
export const getMaterialBOMById = createAsyncThunk(
  "products/getMaterialByBOMId",
  async (bomId: string, { rejectWithValue }) => {
    try {
      const bom = await getMaterialBOMByIdApi(bomId);
      return bom;
    } catch (error: any) {
      return rejectWithValue(error?.message || "Failed to get material BOM");
    }
  },
);
export const createOrUpdateProductBOM = createAsyncThunk<
  ResponseModel,
  {
    payload: any;
  },
  { rejectValue: string }
>(
  "products/createOrUpdateProductBOM",
  async ({ payload }, { rejectWithValue }) => {
    try {
      return await createOrUpdateProductBOMApi(payload);
    } catch (error: any) {
      return rejectWithValue(
        error?.message || "Failed to create/update Product BOM",
      );
    }
  },
);
export const createOrUpdateMaterialBOM = createAsyncThunk(
  "products/createOrUpdateMaterialBOM",
  async (payload: any, { rejectWithValue }) => {
    try {
      await createOrUpdateMaterialBOMApi(payload);
    } catch (error: any) {
      return rejectWithValue(
        error?.message || "Failed to create/update Material BOM",
      );
    }
  },
);
// Create slice with a local reducer to update ranges instantly
const productBOMSlice = createSlice({
  name: "productBOM",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(createOrUpdateProductBOM.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createOrUpdateProductBOM.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(createOrUpdateProductBOM.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(createOrUpdateMaterialBOM.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createOrUpdateMaterialBOM.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(createOrUpdateMaterialBOM.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getProductBOMById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getProductBOMById.fulfilled, (state, action) => {
      state.loading = false;
      state.selectedBom = action.payload;
    });
    builder.addCase(getProductBOMById.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getMaterialBOMById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getMaterialBOMById.fulfilled, (state, action) => {
      state.loading = false;
      state.selectedBom = action.payload;
    });
    builder.addCase(getMaterialBOMById.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default productBOMSlice.reducer;
